import { faShieldCheck } from '@fortawesome/pro-regular-svg-icons'

import { type CoreItem } from '@flecto/types'

import { Badge, type BadgeProps } from '../Badge/Badge'
import { Icon } from '../Icon/Icon'

export type BadgeItemInsuranceProps = BadgeProps & {
  item?: CoreItem
}

export function BadgeItemInsurance({
  item,
  size = 'sm',
  ...props
}: BadgeItemInsuranceProps) {
  if (!item?.insured) {
    return <></>
  }

  return (
    <Badge
      data-testid='badge'
      size={size}
      color='green'
      {...props}
      leftSection={<Icon icon={faShieldCheck} />}
    />
  )
}
